// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"fab4bd51","977":"b4473cf9"}[chunkId] + ".chunk.js";
};